export const PENDING_ENTITY_PROCESSOR_ROUTE = "pendingEntityProcessorRoute";

const isEntityProcessorRoute = (route) =>
  typeof route === "string" && route.startsWith("/entity-processor/");

export const savePendingEntityProcessorRoute = (route) => {
  if (isEntityProcessorRoute(route)) {
    localStorage.setItem(PENDING_ENTITY_PROCESSOR_ROUTE, route);
  }
};

export const takePostLoginDestination = (fallbackRoute) => {
  const route = localStorage.getItem(PENDING_ENTITY_PROCESSOR_ROUTE);
  localStorage.removeItem(PENDING_ENTITY_PROCESSOR_ROUTE);

  return isEntityProcessorRoute(route) ? route : fallbackRoute;
};
